import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Item} from "../../../../../../../framework/model/core/items/item";
import {CartModel} from "../../../../../../../framework/model/core/items/cartModel";
import {ModalController} from "@ionic/angular";
import {Events} from "../../../../../../../framework/providers/events";
import {AppDataService} from "../../../../../../services/AppDataService";
import {OrderService} from "../../../../../../services/OrderService";
import {PropsProvider} from "../../../../providers/props-provider/props-provider.service";
import {BusinessService} from "../../../../../../services/BusinessService";
import {CartService} from "../../../../../../services/CartService";
import {ModelToolsProvider} from "../../../../../../../framework/providers/model-tools/model-tools";
import {ItemProvider} from "../../../../providers/item-provider/item-provider.service";

@Component({
  selector: 'app-item-deal-props',
  templateUrl: './item-deal-props.component.html',
  styleUrls: ['./item-deal-props.component.scss'],
})

export class ItemDealPropsComponent implements OnInit, OnDestroy {

  @Input()
  public model:Item;

  @Input()
  public checkedProps: object = {};

  @Input()
  public cartItem: object = {};

  @Input()
  public cart_model:CartModel;

  @Input()
  public options: object = {};

  @Input()
  public propsEvent: string;

  @Input()
  public btnTitle: string;

  @Input()
  public isItemDetails:boolean=true;

  @Input()
  public comments:string;

  public typesCheck:object = {}

  public cartData;
  public props;

  @Input()
  public prefix = this.tools.getRandomize()+'_props';

  constructor(public events:Events, public appDataService:AppDataService,
              public itemProvider:ItemProvider,
              public orderService:OrderService, public propsProvider:PropsProvider, public tools:ModelToolsProvider,
              public businessService:BusinessService, public cartService:CartService) { }

  ngOnInit() {
    this.props = this.model.data.dealprops;
    this.cartData = this.orderService.getCartData();
    this.initData();
  }

  initData(){

    for(let k in this.props)
    {
      this.typesCheck[this.props[k].id] = {'required':this.props[k].required, 'count':0};

      this.propsProvider.initType(this.checkedProps, this.props[k]);
      this.checkInCase(this.props[k]);
    }

    if(this.cart_model && this.cart_model.data['in_cart'])
    {
      let modelProps = this.cart_model.getValue('props')
      if(modelProps.length)
        this.checkedProps = this.propsProvider.getCheckedProps(modelProps)
    }

    this.events.subscribe(this.prefix+'_propChanged', (params) => {
      this.save();
    }, this.prefix);

    this.events.subscribe('focusType', (params) => {
      this.focusType(params['id'])
    }, this.prefix);
  }

  ngOnDestroy(){
    this.events.unsubscribe('focusType');
  }

  save()
  {
    //console.logthis.checkedProps)
    let props = this.propsProvider.getPropsArr(this.checkedProps, this.typesCheck);
    console.log('save', props)

    for(let k in this.typesCheck)
    {
      if(this.typesCheck[k]['required'] && !this.typesCheck[k]['count'])
      {
        this.focusType(k)
        return
      }
    }

    this.cart_model.setValue('props', props)
    // this.cart_model = this.itemProvider.add_to_cart(this.model, null, 'amount', {
    //   'add_to_value': true,
    //   'force_add_to_cart': false
    // }, this.cart_model)
    this.events.publish(this.prefix + '_cartModelPropsChanged', {'cart_model':this.cart_model})
    console.log('cart_model', this.cart_model)

    // this.initData();
  }

  focusType(typeId)
  {
    // let el = document.getElementById('typeBox_'+typeId);
    // el.scrollIntoView();
    this.events.publish('typeFocus_'+typeId)
  }

  checkInCase(type)
  {
    if(type.typeIncase)
    {
      let incaseRes = this.findPropType(type.typeIncase)
      type['incaseObj'] = incaseRes['obj']
      type['incasePropId'] = incaseRes['propId']
    }
  }

  findPropType(prop)
  {
    for(let t in this.props)
    {
      let type = this.props[t];
      // //console.logthis.props[t])
      for(let p in this.props[t]['props'])
      {
        // //console.logt, this.props[t]['props'][p], prop)
        if(this.props[t]['props'][p]['generalProperty'] == prop)
        {
          if(!this.checkedProps[type['id']]) this.propsProvider.initType(this.checkedProps, type);
          // //console.logtype['id'], this.checkedProps, this.checkedProps[type['id']])
          return {'obj':this.checkedProps[type['id']], 'propId':this.props[t]['props'][p]['id']};
        }
      }
    }

    return {};
  }

}
